import { Dispatch, Fragment, SetStateAction } from "react";
import Icon from "../../../common/Icon";

import styles from "./TransportSelector.module.css";

export enum TransportMode {
    car = "car",
    bike = "bike",
    foot = "foot",
}

export const TransportName = {
    [TransportMode.car]: "자동차",
    [TransportMode.bike]: "자전거",
    [TransportMode.foot]: "도보",
};

interface TransportSelectorProps {
    selectedMode: string;
    setSelectedMode: Dispatch<SetStateAction<TransportMode>>;
    availableModes?: TransportMode[]
}

/**
 * @author smyun
 * @date 2025-01-07
 * @remark 사이드 시트 - 시간별 이동 거리 분석 - 이동 수단
 * @param props TransportSelectorProps
 * @props
 *      selectedMode: 선택한 이동수단
 *      setSelectedMode: 이동수단 선택 setter
 * @returns <TransportSelector>
 */

const TransportSelector = (props: TransportSelectorProps) => {
    const handleSelect = (mode: TransportMode) => {
        props.setSelectedMode(mode);
    };

    const modes = props.availableModes ?? Object.values(TransportMode);

    return (
        <div className={styles.transport_selector}>
            <div key={"trans"} className={styles.radio_buttons}>
                {modes.map((mode) => (
                    <Fragment key={mode}>
                        <button className={`${styles.radio_button} ${props.selectedMode === mode ? `${styles.active}` : ""}`} onClick={() => handleSelect(mode as TransportMode)}>
                            {mode === TransportMode.car && (
                                <span>
                                    <Icon name={"d_car"} size={"middle"} color={props.selectedMode === mode ? "white" : "grey"} />
                                </span>
                            )}
                            {mode === TransportMode.bike && (
                                <span>
                                    <Icon name={"d_bike"} size={"middle"} color={props.selectedMode === mode ? "white" : "grey"} />
                                </span>
                            )}
                            {mode === TransportMode.foot && (
                                <span>
                                    <Icon name={"d_walk"} size={"middle"} color={props.selectedMode === mode ? "white" : "grey"} />
                                </span>
                            )}
                        </button>
                        <span className={styles.label}>{TransportName[mode]}</span>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default TransportSelector;
